import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getReferralListRequest,
  getReferralListSuccess,
  getReferralListFailure,
  createReferralRequest,
  createReferralSuccess,
  createReferralFailure,
} from "./referralSlice";
import { toast } from "react-toastify";

function* fetchReferralList(action) {
  try {
    const payload = action.payload || {};

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/referral/getReferralCodeDetails`,
        {
          params: payload,
        }
      )
    );

    yield put(getReferralListSuccess(response.data));
  } catch (error) {
    yield put(getReferralListFailure(error.message));
    toast.error("Failed to fetch referral list");
  }
}

function* createReferralCode() {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/referral/createReferralCode`
      )
    );

    yield put(createReferralSuccess(response.data));
    // toast.success("Referral code generated successfully");
  } catch (error) {
    yield put(createReferralFailure(error.message));
    toast.error("Failed to generate referral code");
  }
}

export function* referralSaga() {
  yield takeLatest(getReferralListRequest.type, fetchReferralList);
  yield takeLatest(createReferralRequest.type, createReferralCode);
}
